import Footer from "../components/Footer";
import SEO from "../components/SEO";

function CookiePolicyPage() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <SEO
        title="Cookie Policy | KMC Health (Kitmeechai Health)"
        description="Read the KMC Health (Kitmeechai Health) cookie policy to learn how we use cookies on our website."
        path="/cookie-policy"
      />
      <div style={{ flex: 1 }}>
        <div className="privacy-page">
          <div className="privacy-header">
            <h1>Cookie Policy</h1>
          </div>

          <div className="privacy-document">
            <iframe
              src="/cookie-policy.pdf"
              title="Cookie Policy"
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default CookiePolicyPage;
